<!-- Header da Pagina -->
<div class="page-header">
  <div class="header-icon">
    <i class="pi pi-qrcode"></i>
  </div>
  <div class="header-content">
    <h1 class="header-title">{{ 'dados-de-recebimento.texts.titulo' | translate }}</h1>
    <p class="header-subtitle">{{ 'dados-de-recebimento.texts.subtitulo' | translate }}</p>
  </div>
</div>

<div class="cards-container">

  <!-- Coluna Esquerda: formulario -->
  <div class="column-left">
    <div class="form-card">
      <div class="card-header">
        <div class="card-header-icon">
          <i class="pi pi-id-card"></i>
        </div>
        <span class="card-header-title">{{ 'dados-de-recebimento.texts.dados' | translate }}</span>
      </div>

      <div class="card-content">
        <div class="form-grid">
          <div class="form-field half">
            <label class="form-label">
              {{ 'dados-de-recebimento.labels.comercio_id' | translate }}
              <span class="required">*</span>
            </label>
            <p-inputNumber
              [(ngModel)]="form.comercioId"
              [useGrouping]="false"
              [min]="0"
              [class.error-field]="formEnviado && form.comercioId == null"
              [inputStyle]="{ width: '100%' }">
            </p-inputNumber>
          </div>

          <div class="form-field half">
            <label class="form-label">
              {{ 'dados-de-recebimento.labels.sucursal' | translate }}
              <span class="required">*</span>
            </label>
            <p-inputNumber
              [(ngModel)]="form.sucursal"
              [useGrouping]="false"
              [min]="0"
              [class.error-field]="formEnviado && form.sucursal == null"
              [inputStyle]="{ width: '100%' }">
            </p-inputNumber>
          </div>

          <div class="form-field full">
            <label class="form-label">
              {{ 'dados-de-recebimento.labels.chave_publica_qr' | translate }}
              <span class="required">*</span>
            </label>
            <p-password
              [(ngModel)]="form.chavePublica"
              [feedback]="false"
              [toggleMask]="true"
              [class.error-field]="formEnviado && !form.chavePublica"
              [inputStyle]="{ width: '100%' }"
              [placeholder]="'dados-de-recebimento.placeholders.chave' | translate">
            </p-password>
          </div>

          <div class="form-field full">
            <label class="form-label">
              {{ 'dados-de-recebimento.labels.chave_privada_qr' | translate }}
              <span class="required">*</span>
            </label>
            <p-password
              [(ngModel)]="form.chavePrivada"
              [feedback]="false"
              [toggleMask]="true"
              [class.error-field]="formEnviado && !form.chavePrivada"
              [inputStyle]="{ width: '100%' }"
              [placeholder]="'dados-de-recebimento.placeholders.chave' | translate">
            </p-password>
          </div>
        </div>
      </div>
    </div>

    <!--
      Segundo cartao: as chaves do tpago.

      Ficam separadas de proposito. O comercio e a sucursal sao os MESMOS (o cadastro na Bancard
      e unico), mas as chaves sao de outra API — colar uma no lugar da outra devolve 401, que foi
      exatamente o que aconteceu em desenvolvimento.
    -->
    <div class="form-card">
      <div class="card-header">
        <div class="card-header-icon">
          <i class="pi pi-credit-card"></i>
        </div>
        <span class="card-header-title">{{ 'dados-de-recebimento.texts.dados_tpago' | translate }}</span>
      </div>

      <div class="card-content">
        <p class="dr-ajuda">{{ 'dados-de-recebimento.texts.dados_tpago_ajuda' | translate }}</p>

        <div class="form-grid">
          <div class="form-field full">
            <label class="form-label">
              {{ 'dados-de-recebimento.labels.chave_publica_tpago' | translate }}
            </label>
            <p-password
              [(ngModel)]="form.chavePublicaTpago"
              [feedback]="false"
              [toggleMask]="true"
              [inputStyle]="{ width: '100%' }"
              [placeholder]="'dados-de-recebimento.placeholders.chave' | translate">
            </p-password>
          </div>

          <div class="form-field full">
            <label class="form-label">
              {{ 'dados-de-recebimento.labels.chave_privada_tpago' | translate }}
            </label>
            <p-password
              [(ngModel)]="form.chavePrivadaTpago"
              [feedback]="false"
              [toggleMask]="true"
              [inputStyle]="{ width: '100%' }"
              [placeholder]="'dados-de-recebimento.placeholders.chave' | translate">
            </p-password>
          </div>

          <small class="dr-aviso-erro" *ngIf="tpagoIncompleto">
            {{ 'dados-de-recebimento.texts.tpago_incompleto' | translate }}
          </small>
        </div>
      </div>
    </div>

    <!-- Acoes da pagina -->
    <div class="actions-container">
      <button
        pButton
        type="button"
        severity="secondary"
        class="btn-secondary"
        icon="pi pi-times"
        [label]="'common.limpar' | translate"
        (click)="limparForm()">
      </button>
      <button
        pButton
        type="button"
        class="btn-primary"
        icon="pi pi-check"
        [label]="'common.salvar' | translate"
        [loading]="salvando"
        (click)="salvar()">
      </button>
    </div>
  </div>

  <!-- Coluna Direita: situacao e aviso de seguranca -->
  <div class="column-right">
    <div class="form-card">
      <div class="card-header">
        <div class="card-header-icon info-icon">
          <i class="pi pi-info-circle"></i>
        </div>
        <span class="card-header-title">{{ 'dados-de-recebimento.texts.situacao' | translate }}</span>
      </div>

      <div class="card-content">
        <div *ngIf="carregando" class="dr-status dr-status--carregando">
          <i class="pi pi-spin pi-spinner"></i>
          <span>{{ 'common.carregando' | translate }}</span>
        </div>

        <div *ngIf="!carregando && configurado" class="dr-status dr-status--ok">
          <i class="pi pi-check-circle"></i>
          <div>
            <strong>{{ 'dados-de-recebimento.texts.configurado' | translate }}</strong>
            <p *ngIf="atualizadoEm" class="dr-status__detalhe">
              {{ 'dados-de-recebimento.texts.atualizado_em' | translate }}
              {{ atualizadoEm | date: 'dd/MM/yyyy HH:mm' }}
            </p>
          </div>
        </div>

        <div *ngIf="!carregando && !configurado" class="dr-status dr-status--pendente">
          <i class="pi pi-exclamation-triangle"></i>
          <div>
            <strong>{{ 'dados-de-recebimento.texts.nao_configurado' | translate }}</strong>
            <p class="dr-status__detalhe">
              {{ 'dados-de-recebimento.texts.nao_configurado_ajuda' | translate }}
            </p>
          </div>
        </div>

        <!-- Situacao do tpago, independente da do QR: da para ter um sem o outro. -->
        <div *ngIf="!carregando" class="dr-status" [ngClass]="tpagoConfigurado ? 'dr-status--ok' : 'dr-status--pendente'">
          <i class="pi" [ngClass]="tpagoConfigurado ? 'pi-check-circle' : 'pi-exclamation-triangle'"></i>
          <div>
            <strong>
              {{ (tpagoConfigurado ? 'dados-de-recebimento.texts.tpago_configurado'
                                   : 'dados-de-recebimento.texts.tpago_nao_configurado') | translate }}
            </strong>
            <p class="dr-status__detalhe" *ngIf="tpagoConfigurado && tpagoAtualizadoEm">
              {{ 'dados-de-recebimento.texts.atualizado_em' | translate }}
              {{ tpagoAtualizadoEm | date: 'dd/MM/yyyy HH:mm' }}
            </p>
            <p class="dr-status__detalhe" *ngIf="!tpagoConfigurado">
              {{ 'dados-de-recebimento.texts.tpago_nao_configurado_ajuda' | translate }}
            </p>
          </div>
        </div>

        <p class="dr-aviso">
          <i class="pi pi-lock"></i>
          <span>{{ 'dados-de-recebimento.texts.aviso_seguranca' | translate }}</span>
        </p>
      </div>
    </div>

    <!--
      Terceiro cartao: para onde vai o dinheiro cobrado.

      Fica aqui, e nao na tela do Mini Shop, porque e a decisao vizinha das chaves: la se escolhe
      QUAIS formas o cliente ve; aqui, com que cadastro se cobra e em que conta o dinheiro entra.

      Salva na escolha, sem passar pelo botao Salvar: aquele exige as chaves, que a tela nunca
      consegue reler.
    -->
    <div class="form-card">
      <div class="card-header">
        <div class="card-header-icon">
          <i class="pi pi-wallet"></i>
        </div>
        <span class="card-header-title">{{ 'dados-de-recebimento.texts.contas' | translate }}</span>
      </div>

      <div class="card-content">
        <p class="dr-ajuda">{{ 'dados-de-recebimento.texts.contas_ajuda' | translate }}</p>

        <small class="dr-aviso-erro" *ngIf="!contasBancariasGuarani.length">
          {{ 'dados-de-recebimento.texts.contas_sem_contas' | translate }}
        </small>

        <!-- Atalho para a tela de Contas, que abre ja na aba de cadastro, para quem ainda nao
             tem uma conta de banco em guaranis nao ter de procurar o menu. -->
        <div class="dr-acao-conta">
          <button
            pButton
            type="button"
            class="btn-secondary"
            icon="pi pi-plus"
            [label]="'dados-de-recebimento.texts.contas_cadastrar' | translate"
            routerLink="/contas">
          </button>
        </div>

        <div class="form-grid" *ngIf="contasBancariasGuarani.length">
          <div class="form-field full">
            <label class="form-label">
              {{ 'dados-de-recebimento.labels.conta_qrcode' | translate }}
            </label>
            <p-dropdown
              [options]="contasBancariasGuarani"
              [(ngModel)]="contas.contaQrCodeId"
              optionLabel="label"
              optionValue="value"
              [showClear]="true"
              [disabled]="salvandoContas"
              [placeholder]="'dados-de-recebimento.placeholders.conta' | translate"
              styleClass="w-full"
              (onChange)="salvarContas('QR_CODE')">
            </p-dropdown>
          </div>

          <div class="form-field full">
            <label class="form-label">
              {{ 'dados-de-recebimento.labels.conta_tarjeta' | translate }}
            </label>
            <p-dropdown
              [options]="contasBancariasGuarani"
              [(ngModel)]="contas.contaTarjetaId"
              optionLabel="label"
              optionValue="value"
              [showClear]="true"
              [disabled]="salvandoContas"
              [placeholder]="'dados-de-recebimento.placeholders.conta' | translate"
              styleClass="w-full"
              (onChange)="salvarContas('TARJETA')">
            </p-dropdown>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>
